import { useEffect, useState } from 'react';

/**
 * Či má appka sieť.
 *
 * `navigator.onLine` je spoľahlivý iba jedným smerom: keď povie `false`, sieť
 * naozaj nie je. Opačne klame — pripojenie na wifi bez internetu hlási ako
 * online. Preto sa tento hook používa len na to, čo vie povedať isto, a druhú
 * stranu rieši chyba z volania (`isNetworkError` v `lib/api.ts`), ktorá sa
 * ukáže ako upozornenie.
 *
 * Bez toho človek na telefóne klepol na tlačidlo, nič sa nestalo a nemal ako
 * zistiť prečo.
 */
export const useOnline = (): boolean => {
  const [online, setOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);

    // Stav sa mohol zmeniť medzi prvým vykreslením a týmto momentom —
    // napríklad keď sa appka otvorí z ikony už bez signálu.
    setOnline(navigator.onLine);

    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return online;
};
